import { gql } from "@apollo/client";

export const CREATE_CONEXION_MULTIPLE = gql`
mutation CreateConexionMultiple(
    $idEvaluacion: Int!
    $fechaDesde: CustomDateTime!
    $fechaHasta: CustomDateTime!
) {
    createConexionMultiple(
        input: {
            idEvaluacion: $idEvaluacion,
            fechaDesde: $fechaDesde
            fechaHasta: $fechaHasta
        }
    )
    {
        success
        error
    }
}
`;